/* eslint-disable jira/filename-case */
export const PACKAGE_NAME = 'jiraAtlassianNavigationNav4';
export const TEAM_NAME = 'jira-cosmos';
export const EXPERIENCE_NAVIGATION_TOP_MENU = 'viewAtlassianNavigationMenu';
export const EXPERIENCE_ID = 'AtlaskitAtlassianNavigationNav4';

export const LOGIN = 'login' as const;
export const LOGOUT = 'logout' as const;
